import {
  Form,
  message,
  Button,
  Card,
  Input,
  DatePicker,
  Flex,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";

import certificationService from "../../services/certification.service";
import { useParams } from "react-router-dom";
import { PageHeader } from "@ant-design/pro-components";
import { FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";
import { downloadPDF } from "../../Helpers/Functions";
import modificationService from "../../services/modification.service";
import { useQuery } from "react-query";

import { createDate, formatDate } from "../../Helpers/time-utils";
import {
  BonificationGenerator,
  BonificationInput,
} from "./Components/BonificationGenerator";

const DEFAULT_NOTE = "";

const ModificationGenerator = () => {
  const [loading, setLoading] = useState(false);
  const [required, setRequired] = useState(false);
  const [bonifs, setBonifs] = useState<BonificationInput[]>([]);

  const [form] = Form.useForm();
  let { id } = useParams();

  const {
    data: { certification, bonifications } = {},
    isFetching,
    refetch,
  } = useQuery(
    ["certifications", id],
    () => modificationService.getBonifications(id),
    {
      keepPreviousData: false,
      enabled: Number(id) > 0,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (bonifications ) {
      setBonifs(bonifications);
    }
  }, [bonifications]);

  const updateOrCreateBonification = async () => {
    const { observation, date, certificate_number } = form.getFieldsValue();

    const res = await certificationService.updateBonifications(id, {
      observation,
      date,
      certificate_number,
      bonifications: bonifs,
    });
    return res;
  };

  const finish = async () => {
    try {
      const res = await updateOrCreateBonification();
      if (!res.success) {
        message.error(res.message);
        return;
      }
      message.success(res.message);
    } catch (error) {
      message.error(error.message);
    }
  };

  const certificateNow = async () => {
    setRequired(true);
    setTimeout(async () => {
      form
        .validateFields()
        .then(async (values) => {
          setLoading(true);
          await updateOrCreateBonification();
          const res = await certificationService.certificate(id);
          setLoading(false);
          if (!res.success) {
            message.error(res.message);
            return;
          }
          refetch();
          message.success(res.message);
        })
        .catch((err) => {
          setLoading(false);
          message.warning(err?.message || "¡Por favor completa los campos!");
        });
    }, 150);
  };

  const removeModel = () => {};

  useEffect(() => {
    if (certification) {
      form.setFieldsValue({
        certificate_number: certification.certificate_number ?? "DG-26-0",
        date: createDate(certification.date) ?? createDate(),
        observation: certification.observation ?? DEFAULT_NOTE,
      });
    }
  }, [certification, form]);

  return (
    <div className="modification-form-page">
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title={`Modificaciones: ${certification?.plate} / ${
          certification?.inspection_number ?? ""
        }`}
        subTitle={formatDate(new Date(), "LLL")}
        extra={[
          certification?.status === "finished" && (
            <>
              <Button
                icon={<FilePdfOutlined />}
                key="show"
                onClick={() =>
                  downloadPDF(
                    true,
                    certification?.certificate_number,
                    certification?.pdf_url
                  )
                }
                loading={loading || isFetching}
              >
                Ver
              </Button>

            </>
          ),

          certification?.status === "finished" && (
            <Button
              icon={<DownloadOutlined />}
              key="download"
              onClick={() =>
                downloadPDF(
                  false,
                  certification?.certificate_number,
                  certification?.pdf_url
                )
              }
              loading={loading || isFetching}
            >
              Descargar
            </Button>
          ),
          <Button onClick={removeModel} danger key="cancel">
            Anular
          </Button>,
          <Button
            key="modifications"
            loading={loading}
            onClick={certificateNow}
          >
            Certificar
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Guardar
          </Button>,
        ]}
      />

      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        initialValues={{ chassis_status: "NUEVO", type: 1, note_options: "" }}
        onFinish={finish}
      >
        <Flex gap={10} justify="space-between" style={{ width: "100%" }}>
          <div style={{ flex: 1 }}>
            <Spin spinning={isFetching}>
              <Card className="cardex" title="Datos del certificado">
                <Form.Item
                  style={{ width: 200 }}
                  name="certificate_number"
                  label="Número de Certificado"
                  rules={[
                    {
                      required: true,
                      message: "Ingresa el numero de certificado",
                    },
                  ]}
                >
                  <Input
                    autoComplete="off"
                    aria-autocomplete="none"
                    size="middle"
                  />
                </Form.Item>

                <Form.Item
                  style={{ marginTop: 10 }}
                  name="date"
                  label="Fecha de certificación"
                  rules={[{ required: true, message: "Ingresa una fecha" }]}
                >
                  <DatePicker style={{ width: 240 }} size="middle" />
                </Form.Item>

                <Form.Item
                  name="observation"
                  initialValue={DEFAULT_NOTE}
                  label="Observaciones"
                  rules={[{ required: false }]}
                >
                  <Input.TextArea size="middle" />
                </Form.Item>

              { certification &&  <BonificationGenerator
                  value={bonifs}
                  onChange={setBonifs}
                  certification={certification}
                />}
              </Card>
            </Spin>
          </div>
        </Flex>
      </Form>
    </div>
  );
};

const BonificationBase = () => <ModificationGenerator />;

export default BonificationBase;
